import { useEffect, useState } from "react";
import api from "../api";

const API = process.env.REACT_APP_API_URL;

// ✅ Number formatting
const format = (num) =>
  new Intl.NumberFormat("en-IN").format(num || 0);

function Dashboard() {

  const [data, setData] = useState({
    totalStudents: 0,
    totalCollection: 0,
    totalConcession: 0,   // ✅ added
    totalDues: 0,
    defaulters: 0
  });

  useEffect(() => {
    api.get(`${API}/dashboard-summary`)
      .then(res => setData(res.data))
      .catch(err => console.log(err));
  }, []);

  return (
    <div style={container}>
      <h2>Dashboard</h2>

      <div style={grid}>

        {/* Total Students */}
        <div style={card("#2563eb")}>
          <h4>Total Students</h4>
          <p>{data.totalStudents}</p>
        </div>

        {/* Total Collection */}
        <div style={card("#16a34a")}>
          <h4>Total Collection</h4>
          <p>₹{format(data.totalCollection)}</p>
        </div>

        {/* Total Concession */}
        <div style={card("#2563eb")}>
          <h4>Total Concession</h4>
          <p style={{ color: "#2563eb" }}>
            ₹{format(data.totalConcession)}
          </p>
        </div>

        {/* Total Dues */}
        <div style={card("#dc2626")}>
          <h4>Total Dues</h4>
          <p style={{ color: "#dc2626" }}>
            ₹{format(data.totalDues)}
          </p>
        </div>

        {/* Defaulters */}
        <div style={card("#f59e0b")}>
          <h4>Defaulters</h4>
          <p>{data.defaulters}</p>
        </div>

      </div>
    </div>
  );
}

// 🎨 STYLES
const container = {
  padding: "30px"
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "20px"
};

const card = (color) => ({
  background: "#fff",
  padding: "20px",
  borderRadius: "10px",
  borderTop: `5px solid ${color}`,
  textAlign: "center",
  boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
});

export default Dashboard;